<template>
	<div class="ui tiny modal" ref="modal">
        <div class="header">Draga učenka, dragi učenec!</div>
		<div class="content" v-if="showHasAccess">
            <p>Tvoj dostop na iRokus.si je med 8. uro zjutraj in 14. uro popoldne mogoč v skupnem času ene ure za posamezno interaktivno gradivo.</p>
            <p>Neomejen dostop smo ti omogočili od 14. ure popoldne do 8. ure zjutraj ter ves dan ob dnevih brez pouka.</p>
            <div class="field">
                <div class="ui checkbox">
                    <input ref="cookie-check" type="checkbox" name="hide-access-restriction" id="hide-access-restriction" class="hidden">
                    <label for="hide-access-restriction">Tega sporočila ne kaži več.</label>
                </div>
            </div>
		</div>
        <div class="content" v-if="showHasNoAccess">
            <p>Čas je potekel. Tvoj dostop na iRokus.si je med 8. uro zjutraj in 14. uro popoldne mogoč v skupnem času ene ure za posamezno interaktivno gradivo.</p>
            <p>Neomejen dostop smo ti omogočili od 14. ure popoldne do 8. ure zjutraj ter ves dan ob dnevih brez pouka.</p>
		</div>
		<div class="actions">
            <div class="ui button approve" v-on:click="close()">Nazaj v iZbirko</div>
			<div class="ui yellow button approve"  v-if="showHasAccess" v-on:click="close(true)">V redu</div>
		</div>
	</div>
</template>

<script>
	import popup from './Popup.vue'

    export default {
    	mixins: [popup],
        props: ['data'],
    	methods: {
    		close(advance) {
                if (advance) {
                    this.data.callback(this.data.credit, true);
                }
            },
            onCookiePresent() {
                this.close(true);
                this.$root.$emit('close-popup', this);
            }
        },
        computed: {
            showHasAccess() {
                return this.data.withinTimeRestriction && this.data.hasAccess;
            },
            showHasNoAccess() {
                return !this.data.hasAccess;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/HasAccess.vue